<div class="simple-notification">
  <div class="message">
    {{ message }}
  </div>
  <div class="action">
    <button *ngFor="let action of actions" id="{{action.button_id}}">{{action.label}}</button>
  </div>
</div>
